module.exports = __webpack_public_path__ + "assets/img/FAQs-vector-mobile.41d96b48.svg";